export const AWS_ORGANIZATIONS = "AWS_ORGANIZATIONS";
export const GLOBAL_RESOURCES_TEMPLATE_FILENAME = "global-resources.template";
export const DEFAULT_COSTS_INTERVAL = { type: "relative", unit: "day", amount: 5 };
